import {
  FieldValueSource,
  TicketInputProvenance,
} from 'features/libra/ontology/ontologyFieldTypes'

/**
 * Stable-path keys for the ticket-resident provenance overlay
 * (`ticket.inputProvenance`). The keys namespace by store and — for
 * asset-model fields — by component, so a multi-component ticket's intrinsic
 * fields never collide.
 *
 * IMPORTANT: keys are derived from stable identifiers (component id + the
 * asset-model JSON field key, or the ffs-config field key), NEVER from display
 * labels. A label rename must not orphan a citation.
 */

/** Provenance key for a value stored on the asset-model snapshot component. */
export const assetModelProvenanceKey = (
  componentId: string,
  field: string
): string => `assetModel:${componentId}:${field}`

/** Provenance key for a value stored on the ffs-configuration entry. */
export const ffsConfigProvenanceKey = (field: string): string =>
  `ffsConfig:${field}`

/**
 * Resolve the citation for a stable field-path key. Returns null when the key
 * is absent OR present-but-uncited (an explicit null the extraction path may
 * write to record "value set, no source found").
 */
export const getInputProvenanceSource = (
  provenance: TicketInputProvenance | undefined,
  key: string
): FieldValueSource | null => provenance?.[key] ?? null
